import { type PropsWithChildren } from 'react';
import { isServer } from '@toss/utils';
import { type NextPageWithLayout } from 'next';
import { RedirectWhenUnauthenticated } from './RedirectWhenUnauthenticated';
import { RenderConditionChecker } from './RenderConditionChecker';
interface AuthOptions {
  callbackUrl?: string;
  redirectPath?: string;
  additionalRenderCondition?: {
    shouldCheckRegistrationStatus?: boolean;
    shouldCheckAdmin?: boolean;
  };
}
export function withPageAuth<P extends object>(PageComponent: NextPageWithLayout<P>, options: AuthOptions = {}) {
  const {
    callbackUrl = '',
    redirectPath = '/login',
    additionalRenderCondition = {}
  } = options;
  return Object.assign((props: PropsWithChildren<P>) => isServer() ? null : <RedirectWhenUnauthenticated redirectPath={redirectPath} callbackUrl={callbackUrl}>
          <RenderConditionChecker {...additionalRenderCondition}>
            <PageComponent {...props} />
          </RenderConditionChecker>
        </RedirectWhenUnauthenticated>, {
    getLayout: PageComponent.getLayout
  });
}